import { Component, NgZone, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { DigitalMemoryLogService } from "../../services/digital-memory-log.service";
import { toUrlFriendlySlug } from "src/app/shared/utils/url-slug.util";

@Component({
  selector: "app-ships-gallery",
  templateUrl: "./ships-gallery.component.html",
  styleUrls: ["./ships-gallery.component.scss"],
})
export class ShipGalleryComponent implements OnInit {
  site = environment["site"];
  ships: any[] = [];
  loading = false;

  constructor(
    private digitalMemoryLogService: DigitalMemoryLogService,
    protected router: Router,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.loading = true;
    this.digitalMemoryLogService.getShipList().subscribe(
      (res: any[]) => {
        this.ships = res;
        this.loading = false;
      },
      err => {
        this.loading = false;
      }
    );
  }

  onShipClick(ship) {
    this.ngZone.run(() => {
      const urlFriendlyName = toUrlFriendlySlug(ship.name, { emptyFallback: "ship" });
      const shipUrl = `ship-${urlFriendlyName}-${ship.id}`;

      this.router.navigate(["/overview", shipUrl]).catch(error => {
        window.location.href = `/overview/${shipUrl}`;
      });
    });
  }
}
